<template>
	<div
		class="modal fade"
		ref="modal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
	>
		<div class="modal-backdrop" @click="close"></div>
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<button
						type="button"
						class="modal-close"
						data-dismiss="modal"
						aria-label="Close"
					>
						<i class="sk-icon-times"></i>
					</button>
					<img
						class="modal-hero-image"
						src="/images/2k-phone.png"
						alt="Phone"
					/>
					<h1 class="modal-title">Need Help?</h1>
					<h2 class="modal-subtitle">
						We’re here to help with anything you need.
						<br />
						Start by texting us below.
					</h2>
					<a href="sms:+18559823181" class="button button-primary">
						(855) 982-3181
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SupportModal",
	methods: {
		open() {
			$(this.$refs.modal).modal("show")
		},
		close() {
			$(this.$refs.modal).modal("hide")
		}
	}
}
</script>

<style scoped>
.modal-backdrop {
	opacity: 0.7;
}

.modal-dialog {
	z-index: 2000;
}

.modal-body {
	text-align: center;
}

.modal-title {
	font-size: 24px;
	margin-top: 25px;
}

.button-primary {
	text-align: center;
    vertical-align: middle;
	line-height: 50px;
	margin-top: 50px !important;
}
</style>
